import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Cloche = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.268 13.331a8.637 8.637 0 0 1 17.273 0M10.268 7.312a6.26 6.26 0 0 0-4.362 4.306M1.904 15.15h20M10.464 3.6a1.439 1.439 0 0 1 2.781-.563q.106.272.099.563M4.587 17.488l3.186-.51a7.76 7.76 0 0 1 4.714.594c1.39.761.044 2.314-3.155 1.2m-4.86 2.2c3.586-.822 4.335 2.04 7.33 1.141 8.324-2.5 12.55-6.536 2.68-4.09"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Cloche) as SvgIcon;
export { ForwardRef as ReactComponent };
